import RWS from "reconnecting-websocket";

export const setUpConnection = () => path => {
    const webSocketProtocol =
        window.location.protocol === "https:" ? "wss:" : "ws:";

    const wsPath = `${webSocketProtocol}//${window.location.host}/websockets${path}`;
    const connection = new RWS(wsPath);
    return connection;
};
